module.exports = __webpack_public_path__ + "static/img/edit-field.692d10fd.svg";